import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ba59fee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "body" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "back" }
const _hoisted_4 = { class: "form-content" }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "reset-tip" }
const _hoisted_7 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_8 = {
  key: 0,
  class: "error",
  style: {"font-size":"12px","white-space":"nowrap"}
}
const _hoisted_9 = { style: {"margin-top":"29px"} }
const _hoisted_10 = { style: {"font-size":"12px","line-height":"18px"} }
const _hoisted_11 = {
  class: "btn",
  style: {"margin-top":"29px"}
}

import { ref, onBeforeUnmount, inject } from 'vue'
import { ElMessage } from 'element-plus'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getUserValidateType, sendCaptcha, verifyCaptcha, resetPassword } from '@/services/accounts'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const $t: any = inject('$t')
const router = useRouter()
const store = useStore()

const userInfo = ref<any>(null)
const formRef = ref<any>(null)
const isNextLoading = ref(false)
const checkEmployeeCode = async (rules: any, value: string, callback: any) => {
  if (active.value === 0) {
    try {
      isNextLoading.value = true
      const { data } = await getUserValidateType(value)
      userInfo.value = data
      callback()
    } catch (error: any) {
      if (error.status === 400) {
        callback(new Error(error.message))
      } else {
        callback(new Error(' '))
      }
      console.log(error)
    } finally {
      isNextLoading.value = false
    }
  } else {
    callback()
  }
}

const captchaData = ref<any>(null)
const checkCaptcha = async (rules: any, value: string, callback: any) => {
  if (active.value === 2) {
    try {
      isNextLoading.value = true
      const { data } = await verifyCaptcha(form.value.employeeCode, form.value.captcha)
      captchaData.value = data
      callback()
    } catch (error: any) {
      if (error.status === 400) {
        callback(new Error(error.message))
      } else {
        callback()
      }
      console.log(error)
    } finally {
      isNextLoading.value = false
    }
  }
}

const checkPassword = (value: string, confirmValue: string) => {
  // 判断条件一 长度
  const isLen = value.length >= 8 && value.length <= 16
  messageObj.value[0].status = isLen

  // 判断条件二 3种格式
  const pwdRegex1 = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9])') // 包含字母、数字和特殊字符
  const pwdRegex2 = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])') // 包含大小写字母，特殊字符
  const pwdRegex3 = new RegExp('(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])') // 包含大小写字母，数字
  const isType = pwdRegex1.test(value) || pwdRegex2.test(value) || pwdRegex3.test(value)
  messageObj.value[1].status = isType

  // 判断条件三 连续数字
  const pwdRegNum = /^(?!.*(\d)\1{2}).*$/
  const pwdFuncNum = () => {
    const arr = value.split('')
    for (let i = 0; i < arr.length - 1; i++) {
      const numStr: any = value.substr(i, 3)
      if (!isNaN(numStr) && Number(numStr) > 0) {
        const numArr = numStr.split('')
        const firstNum = Number(numArr[0])
        const secondNum = Number(numArr[1])
        const thirdNum = Number(numArr[2])
        if (secondNum - firstNum === 1 && thirdNum - secondNum === 1) {
          return false
        }
      }
    }
    return true
  }
  const isMatchNum = (pwdRegNum.exec(value) && pwdFuncNum()) as boolean
  messageObj.value[2].status = isMatchNum

  // 判断是否相同
  const isSame = value === confirmValue
  messageObj.value[3].status = isSame

  isCheckPassword.value = messageObj.value.some(item => !item.status)
}

// 按正序顺序获取非法输入messageList
const getIllegalMessageObj = () => {
  try {
    const result = []
    if (!messageObj.value?.length) {
      return result
    }
    messageObj.value.forEach(element => {
      if (!element?.status) {
        result.push(element)
      }
    })
    return result
  } catch (error) {
    console.log(error)
  }
}

const isCheckPassword = ref(false)
const messageObj = ref([
  {
    status: false,
    message: $t('main_header_messageObj_length')
  },
  {
    status: false,
    message: $t('main_header_messageObj_three_condition')
  },
  {
    status: false,
    message: $t('main_header_messageObj_no_repeat')
  },
  {
    status: true,
    message: $t('main_header_messageObj_twice_different')
  }
])

const active = ref(0)

const isNext = ref(true)
const handleNext = async () => {
  if (active.value === 0 || active.value === 2) {
    try {
      await formRef.value.validate()
      active.value++
    } catch (error) {
      console.log(error)
    }
  } else {
    active.value++
  }

  if (active.value === 1) {
    currentType.value = userInfo.value.ValidateTypeList[0]
    form.value.findType = currentType.value.Type
    isNext.value = currentType.value.IsEnabled
  }
}

const isSubmitLoading = ref(false)
const handleSubmit = async () => {
  try {
    await formRef.value.validate()
    checkPassword(form.value.password, form.value.confirmPassword)
    if (!isCheckPassword.value) {
      isSubmitLoading.value = true
      await resetPassword({
        Token: captchaData.value.Token,
        EmployeeCode: form.value.employeeCode,
        NewPassword: form.value.password
      })
      ElMessage({
        type: 'success',
        message: $t('main_login_reset_password_succeeded')
      })
      toLogin()
    }
  } catch (error) {
    console.log(error)
  } finally {
    isSubmitLoading.value = false
  }
}

const form = ref({
  employeeCode: '',
  findType: '',
  captcha: '',
  password: '',
  confirmPassword: ''
})
const formRules = {
  employeeCode: [
    { required: true, message: $t('main_login_work_number_input'), trigger: 'blur' },
    { validator: checkEmployeeCode, trigger: 'none' }
  ],
  captcha: [
    { required: true, len: 6, message: $t('main_login_six_verification_code'), trigger: 'blur' },
    { validator: checkCaptcha, trigger: 'none' }
  ],
  password: [{ required: true, message: $t('main_login_password_tip'), trigger: 'blur' }],
  confirmPassword: [{ required: true, message: $t('main_login_password_tip'), trigger: 'blur' }]
}

const currentType = ref<any>(null)
const handleChangeType = (type: string) => {
  currentType.value = userInfo.value.ValidateTypeList.find((item: any) => item.Type === type)
  isNext.value = currentType.value.IsEnabled
}

const formatTypeMessage = (typeItem: any) => {
  switch (typeItem.Type) {
    case 'Email':
      return `${$t('main_login_mail')} ${typeItem.Receiver || '-'} ${$t(
        'main_login_retrieve_password'
      )}`
    default:
      return $t('main_login_unknown_way')
  }
}

const isSendLoading = ref(false)
const isAwait = ref(false)
const currentCountDown = ref(60)
let sendTimer: any = null
const countDown = () => {
  currentCountDown.value--
  if (currentCountDown.value === 0) {
    isAwait.value = false
    currentCountDown.value = 60
    clearTimeout(sendTimer)
    sendTimer = null
    return
  }
  sendTimer = setTimeout(() => {
    countDown()
  }, 1000)
}
const handleSendCaptcha = async () => {
  try {
    isSendLoading.value = true
    await sendCaptcha(form.value.employeeCode, form.value.findType)
    isAwait.value = true
    countDown()
  } catch (error) {
    console.log(error)
  } finally {
    isSendLoading.value = false
  }
}

const toLogin = () => {
  store.commit('menu/resetTab')
  store.commit('menu/changeCurrentMenu', '')
  store.commit('user/setUserInfo', null)
  router.push({
    name: 'Login'
  })
}

onBeforeUnmount(() => {
  clearTimeout(sendTimer)
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          type: "text",
          icon: "el-icon-arrow-left",
          onClick: toLogin
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref($t)('main_login_retrieve_back')), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_el_steps, {
        active: active.value,
        "finish-status": "success",
        class: "steps-content"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_step, {
            title: _unref($t)('main_login_select_account')
          }, null, 8, ["title"]),
          _createVNode(_component_el_step, {
            title: _unref($t)('main_login_select_way')
          }, null, 8, ["title"]),
          _createVNode(_component_el_step, {
            title: _unref($t)('main_login_authentication')
          }, null, 8, ["title"]),
          _createVNode(_component_el_step, {
            title: _unref($t)('main_login_reset_password')
          }, null, 8, ["title"])
        ]),
        _: 1
      }, 8, ["active"]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          ref_key: "formRef",
          ref: formRef,
          model: form.value,
          rules: formRules,
          onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            (active.value === 0)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: _unref($t)('main_login_work_number') + '：',
                  prop: "employeeCode"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: form.value.employeeCode,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.employeeCode) = $event)),
                      placeholder: _unref($t)('main_login_work_number_tip')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true),
            (active.value === 1)
              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: form.value.findType,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.value.findType) = $event)),
                      onChange: handleChangeType
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userInfo.value.ValidateTypeList, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_radio, {
                            key: index,
                            label: item.Type
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(formatTypeMessage(item)) + " ", 1),
                              _createElementVNode("span", {
                                style: {"margin-left":"20px"},
                                class: _normalizeClass([item.IsEnabled ? 'success' : 'error'])
                              }, [
                                _createElementVNode("i", {
                                  class: _normalizeClass([item.IsEnabled ? 'el-icon-success' : 'el-icon-error'])
                                }, null, 2),
                                _createTextVNode(" " + _toDisplayString(item.Message), 1)
                              ], 2)
                            ]),
                            _: 2
                          }, 1032, ["label"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (active.value === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_unref($t)('main_login_customer_tip')) + " ", 1),
                    _createElementVNode("b", null, _toDisplayString(`${userInfo.value.UserName}(${form.value.employeeCode})`), 1),
                    _createTextVNode(" " + _toDisplayString(_unref($t)('main_login_operation_tip')), 1)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_unref($t)('main_login_verification_code')) + " " + _toDisplayString(currentType.value.Receiver), 1),
                  _createVNode(_component_el_form_item, { prop: "captcha" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_el_input, {
                          modelValue: form.value.captcha,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.captcha) = $event)),
                          placeholder: _unref($t)('main_login_verification_code_tip')
                        }, null, 8, ["modelValue", "placeholder"]),
                        _createVNode(_component_el_button, {
                          type: "primary",
                          style: {"margin-left":"10px","width":"120px"},
                          loading: isSendLoading.value,
                          disabled: isAwait.value,
                          onClick: handleSendCaptcha
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(isAwait.value ? `${currentCountDown.value}s` : _unref($t)('main_login_send_verification_code')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading", "disabled"])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            (active.value === 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_el_form_item, {
                    label: _unref($t)('main_login_work_number') + '：',
                    "label-width": "140px"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(form.value.employeeCode), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _unref($t)('main_login_name') + '：',
                    "label-width": "140px"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(userInfo.value.UserName), 1)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _unref($t)('main_login_new_password') + '：',
                    prop: "password",
                    "label-width": "140px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.password) = $event)),
                        type: "password",
                        placeholder: _unref($t)('main_login_new_password_tip'),
                        autocomplete: "new-password",
                        onInput: _cache[4] || (_cache[4] = ($event: any) => (checkPassword(form.value?.password, form.value?.confirmPassword))),
                        onChange: _cache[5] || (_cache[5] = ($event: any) => (checkPassword(form.value?.password, form.value?.confirmPassword)))
                      }, null, 8, ["modelValue", "placeholder"]),
                      (isCheckPassword.value && getIllegalMessageObj?.()?.length)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(getIllegalMessageObj?.()?.[0]?.message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _unref($t)('main_login_new_password_again_tip') + '：',
                    prop: "confirmPassword",
                    "label-width": "140px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: form.value.confirmPassword,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.confirmPassword) = $event)),
                        type: "password",
                        placeholder: _unref($t)('main_login_new_password_again_tip'),
                        autocomplete: "new-password",
                        onInput: _cache[7] || (_cache[7] = ($event: any) => (checkPassword(form.value?.password, form.value?.confirmPassword))),
                        onChange: _cache[8] || (_cache[8] = ($event: any) => (checkPassword(form.value?.password, form.value?.confirmPassword)))
                      }, null, 8, ["modelValue", "placeholder"]),
                      _createElementVNode("ul", _hoisted_9, [
                        _createElementVNode("li", _hoisted_10, _toDisplayString(_unref($t)('main_header_messageObj_prompt')) + "： ", 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messageObj.value, (item, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: index,
                            style: {"font-size":"12px","line-height":"18px"}
                          }, [
                            _createElementVNode("span", null, _toDisplayString(index + 1) + "." + _toDisplayString(item.message), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model"]),
        _createElementVNode("div", _hoisted_11, [
          (active.value !== 3)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                disabled: !isNext.value,
                onClick: handleNext
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)('main_login_next_step')), 1)
                ]),
                _: 1
              }, 8, ["disabled"]))
            : _createCommentVNode("", true),
          (active.value === 3)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                loading: isSubmitLoading.value,
                onClick: handleSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref($t)('main_login_save')), 1)
                ]),
                _: 1
              }, 8, ["loading"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})